var cannotLoadAjax = "Can not process your request";
$(document).ready(function() {
  var innovaApiUrl = $("#InnovaApiUrl").val();
  var innovaApiKey = $("#InnovaKey").val();
  var sku = $("#Tool").val();
  if(sku != null && sku != undefined && sku != ""){
    var url = innovaApiUrl + "/products/" + sku + "/full-features/?r=" + Math.random();
    $.ajax({
      type: "GET",
      crossOrigin: true,
      url: url,
      beforeSend: function(xhr) {
        xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
      },
      error: function (request, status, error) {
        if(request.status != 0){
          alert(cannotLoadAjax);
        }
      },
      success: function(result) {
        if (result.message.success) $("#fullFeatureResult").html(renderFullFeatures(result));
        if (result.data !== undefined && result.data.length > 0) {
          $('[data-toggle="tooltip"]').tooltip();
          $("#fullFeatureContent").show();
          $("#fullFeatureLink").show();
        } else {
          $("#fullFeatureContent").hide();
          $("#fullFeatureLink").hide();
        }
        $("img").error(function() {
          $(this).hide();
        });
      }
    });
  }
});

function renderFullFeatures(data) {
  var result = "";
  var fullFeatures = data.data;
  if (data.imageFeature != undefined && data.imageFeature != "") {
    result += "<div class='col-lg-3 col-md-4 mb-3 text-center'>";
    result += "<img src='" + data.imageFeature + "' width='240'>";
    result += " </div>";
  }
  result += "<div class='col-lg-9 col-md-8 mb-3'>";
  if (data.imageFeatureLogo != undefined && data.imageFeatureLogo != "") {
    result += "<img src='" + data.imageFeatureLogo + "' width='258'>";
  }
  if (fullFeatures !== undefined && fullFeatures.length > 0) {
    result += "<p class='my-4'><img src='https://cdn.shopify.com/s/files/1/0266/1302/2766/files/question.svg?v=1596008236' width='20'> Hover or click on icons for details </p>";
    result += "<ul class='inv-product-full-feature-list'>";
    for (var i = 0; i < fullFeatures.length; i++) {
      switch (fullFeatures[i].featureType) {
        case "CheckEngine":
          var title = fullFeatures[i].title == undefined || fullFeatures[i].title == null || fullFeatures[i].title == "" ? "Check Engine: Read and Clear Trouble Codes" : fullFeatures[i].title;
          result += "<li>";
          result += "<a href='javascript:;' data-toggle='tooltip' data-placement='top' title='' class='d-block' data-original-title='" + title + "'>";
          result += "<img src='https://cdn.shopify.com/s/files/1/0266/1302/2766/files/pf-icon-check-engine.svg?v=1596167419' >";
          result += "</a>";
          result += "</li>";
          break;
        case "Smog":
          var title = fullFeatures[i].title == undefined || fullFeatures[i].title == null || fullFeatures[i].title == "" ? "Emissions/Smog Check Readiness LED Indicators" : fullFeatures[i].title;
          result += "<li>";
          result += "<a href='javascript:;' data-toggle='tooltip' data-placement='top' title='' class='d-block' data-original-title='" + title + "'>";
          result += "<img src='https://cdn.shopify.com/s/files/1/0266/1302/2766/files/pf-icon-smog.svg?v=1596167419' >";
          result += "</a>";
          result += "</li>";
          break;
        case "ABS":
          var title = fullFeatures[i].title == undefined || fullFeatures[i].title == null || fullFeatures[i].title == "" ? "ABS/Brake Codes: Read and Clear" : fullFeatures[i].title;
          result += "<li>";
          result += "<a href='javascript:;' data-toggle='tooltip' data-placement='top' title='' class='d-block' data-original-title='" + title + "'>";
          result += "<img src='https://cdn.shopify.com/s/files/1/0266/1302/2766/files/pf-icon-abs.svg?v=1596167418' >";
          result += "</a>";
          result += "</li>";
          break;
        case "BatterySystemCheck":
          var title = fullFeatures[i].title == undefined || fullFeatures[i].title == null || fullFeatures[i].title == "" ? "Battery/Charging System Test" : fullFeatures[i].title;
          result += "<li>";
          result += "<a href='javascript:;' data-toggle='tooltip' data-placement='top' title='' class='d-block' data-original-title='" + title + "'>";
          result += "<img src='https://cdn.shopify.com/s/files/1/0266/1302/2766/files/pf-icon-battery-system-check.svg?v=1596167419' >";
          result += "</a>";
          result += "</li>";
          break;
        case "LiveData":
          var title = fullFeatures[i].title == undefined || fullFeatures[i].title == null || fullFeatures[i].title == "" ? "View Live Data Stream" : fullFeatures[i].title;
          result += "<li>";
          result += "<a href='javascript:;' data-toggle='tooltip' data-placement='top' title='' class='d-block' data-original-title='" + title + "'>";
          result += "<img src='https://cdn.shopify.com/s/files/1/0266/1302/2766/files/pf-icon-stream-live-data.svg?v=1596167420' >";
          result += "</a>";
          result += "</li>";
          break;
        case "OBD2Modes":
          var title = fullFeatures[i].title == undefined || fullFeatures[i].title == null || fullFeatures[i].title == "" ? "Supports All 10 OBD2 Modes" : fullFeatures[i].title;
          result += "<li>";
          result += "<a href='javascript:;' data-toggle='tooltip' data-placement='top' title='' class='d-block' data-original-title='" + title + "'>";
          result += "<img src='https://cdn.shopify.com/s/files/1/0266/1302/2766/files/pf-icon-10-obd2-modes.svg?v=1596167419' >";
          result += "</a>";
          result += "</li>";
          break;
        case "OilLevel":
          var title = fullFeatures[i].title == undefined || fullFeatures[i].title == null || fullFeatures[i].title == "" ? "Oil Level & Oil Life" : fullFeatures[i].title;
          result += "<li>";
          result += "<a href='javascript:;' data-toggle='tooltip' data-placement='top' title='' class='d-block' data-original-title='" + title + "'>";
          result += "<img src='https://cdn.shopify.com/s/files/1/0266/1302/2766/files/pf-icon-oil-level.svg?v=1596167419' >";
          result += "</a>";
          result += "</li>";
          break;
        case "OilLightReset":
          var title = fullFeatures[i].title == undefined || fullFeatures[i].title == null || fullFeatures[i].title == "" ? "Oil Light Reset" : fullFeatures[i].title;
          result += "<li>";
          result += "<a href='javascript:;' data-toggle='tooltip' data-placement='top' title='' class='d-block' data-original-title='" + title + "'>";
          result += "<img src='https://cdn.shopify.com/s/files/1/0266/1302/2766/files/pf-icon-oil-light-reset.svg?v=1596167419' >";
          result += "</a>";
          result += "</li>";
          break;
        case "SRS":
          var title = fullFeatures[i].title == undefined || fullFeatures[i].title == null || fullFeatures[i].title == "" ? "SRS/Airbag Codes: Read and Clear" : fullFeatures[i].title;
          result += "<li>";
          result += "<a href='javascript:;' data-toggle='tooltip' data-placement='top' title='' class='d-block' data-original-title='" + title + "'>";
          result += "<img src='https://cdn.shopify.com/s/files/1/0266/1302/2766/files/pf-icon-srs.svg?v=1596167418' >";
          result += "</a>";
          result += "</li>";
          break;
        case "NetworkScan":
          var title = fullFeatures[i].title == undefined || fullFeatures[i].title == null || fullFeatures[i].title == "" ? "All System Network Scan" : fullFeatures[i].title;
          result += "<li>";
          result += "<a href='javascript:;' data-toggle='tooltip' data-placement='top' title='' class='d-block' data-original-title='" + title + "'>";
          result += "<img src='https://cdn.shopify.com/s/files/1/0266/1302/2766/files/pf-icon-network-scan.svg?v=1596167418' >";
          result += "</a>";
          result += "</li>";
          break;
        case "BatteryReset":
          var title = fullFeatures[i].title == undefined || fullFeatures[i].title == null || fullFeatures[i].title == "" ? "BMS/Battery Reset & Initialization" : fullFeatures[i].title;
          result += "<li>";
          result += "<a href='javascript:;' data-toggle='tooltip' data-placement='top' title='' class='d-block' data-original-title='" + title + "'>";
          result += "<img src='https://cdn.shopify.com/s/files/1/0266/1302/2766/files/pf-icon-battery-reset.svg?v=1596167419' >";
          result += "</a>";
          result += "</li>";
          break;
        case "HybridBattery":
          var title = fullFeatures[i].title == undefined || fullFeatures[i].title == null || fullFeatures[i].title == "" ? "Read Hybrid Battery Cell Voltage" : fullFeatures[i].title;
          result += "<li>";
          result += "<a href='javascript:;' data-toggle='tooltip' data-placement='top' title='' class='d-block' data-original-title='" + title + "'>";
          result += "<img src='https://cdn.shopify.com/s/files/1/0266/1302/2766/files/pf-icon-hybrid-battery-cell-voltage.svg?v=1596167418' >";
          result += "</a>";
          result += "</li>";
          break;
        case "EpbAbsService":
          var title = fullFeatures[i].title == undefined || fullFeatures[i].title == null || fullFeatures[i].title == "" ? "EPB/ABS Brake Bleeding/Caliper Service/Brake Pad Life" : fullFeatures[i].title;
          result += "<li>";
          result += "<a href='javascript:;' data-toggle='tooltip' data-placement='top' title='' class='d-block' data-original-title='" + title + "'>";
          result += "<img src='https://cdn.shopify.com/s/files/1/0266/1302/2766/files/pf-icon-abs-bleeding.svg?v=1596167419' >";
          result += "</a>";
          result += "</li>";
          break;
        case "TirePressure":
          var title = fullFeatures[i].title == undefined || fullFeatures[i].title == null || fullFeatures[i].title == "" ? "Reads TPMS/Tire Pressure" : fullFeatures[i].title;
          result += "<li>";
          result += "<a href='javascript:;' data-toggle='tooltip' data-placement='top' title='' class='d-block' data-original-title='" + title + "'>";
          result += "<img src='https://cdn.shopify.com/s/files/1/0266/1302/2766/files/pf-icon-tpms-tire-pressure.svg?v=1596167418' >";
          result += "</a>";
          result += "</li>";
          break;
        case "TranmissionTemp":
          var title = fullFeatures[i].title == undefined || fullFeatures[i].title == null || fullFeatures[i].title == "" ? "Reads Transmission Temp" : fullFeatures[i].title;
          result += "<li>";
          result += "<a href='javascript:;' data-toggle='tooltip' data-placement='top' title='' class='d-block' data-original-title='" + title + "'>";
          result += "<img src='https://cdn.shopify.com/s/files/1/0266/1302/2766/files/pf-icon-transmission-temperature.svg?v=1596167418' >";
          result += "</a>";
          result += "</li>";
          break;
        case "SpecialReset":
          var title = fullFeatures[i].title == undefined || fullFeatures[i].title == null || fullFeatures[i].title == "" ? "Special Reset Function: SAS, DPF Regen, etc." : fullFeatures[i].title;
          result += "<li>";
          result += "<a href='javascript:;' data-toggle='tooltip' data-placement='top' title='' class='d-block' data-original-title='" + title + "'>";
          result += "<img src='https://cdn.shopify.com/s/files/1/0266/1302/2766/files/pf-icon-special-reset-functions.svg?v=1596167418' >";
          result += "</a>";
          result += "</li>";
          break;
        case "EnhancedDataStream":
          var title = fullFeatures[i].title == undefined || fullFeatures[i].title == null || fullFeatures[i].title == "" ? "Enhanced Data Stream: Engine, AT, ABS, SRS" : fullFeatures[i].title;
          result += "<li>";
          result += "<a href='javascript:;' data-toggle='tooltip' data-placement='top' title='' class='d-block' data-original-title='" + title + "'>";
          result += "<img src='https://cdn.shopify.com/s/files/1/0266/1302/2766/files/pf-icon-enhanced-data-stream.svg?v=1596167419' >";
          result += "</a>";
          result += "</li>";
          break;
        case "BiDirectionalActiveTest":
          var title = fullFeatures[i].title == undefined || fullFeatures[i].title == null || fullFeatures[i].title == "" ? "Active / Bi-Directional System Tests" : fullFeatures[i].title;
          result += "<li>";
          result += "<a href='javascript:;' data-toggle='tooltip' data-placement='top' title='' class='d-block' data-original-title='" + title + "'>";
          result += "<img src='https://cdn.shopify.com/s/files/1/0266/1302/2766/files/pf-icon-bi-directional-active-test.svg?v=1596167418' >";
          result += "</a>";
          result += "</li>";
          break;
        case "Obd1Coverage":
          var title = fullFeatures[i].title == undefined || fullFeatures[i].title == null || fullFeatures[i].title == "" ? "OBD1 Coverage" : fullFeatures[i].title;
          result += "<li>";
          result += "<a href='javascript:;' data-toggle='tooltip' data-placement='top' title='' class='d-block' data-original-title='" + title + "'>";
          result += "<img src='https://cdn.shopify.com/s/files/1/0266/1302/2766/files/pf-icon-obd1.svg?v=1596167419' >";
          result += "</a>";
          result += "</li>";
          break;
      }
    }
    result += "</ul>";
  } else {
    result += "<p>No Full Feature Found.</p>";
  }
  result += " </div>";
  return result;
}